module.exports = __webpack_public_path__ + "img/sycm.55d6aaf1.gif";